
import { 
  Settings, 
  MapPinIcon
} from "lucide-react";
import type { MenuItem } from "../types";

export const servicesSection: MenuItem = {
  title: "الخدمات",
  href: "#",
  icon: Settings,
  color: "from-blue-600 to-blue-700",
  subItems: [
    {
      title: "الخدمات",
      href: "/services",
      icon: Settings,
      color: "from-blue-600 to-blue-700",
    },
    {
      title: "ربط الخدمة بالدولة",
      href: "/service-country-mapping",
      icon: MapPinIcon,
      color: "from-green-500 to-green-600",
    }
  ]
};
